var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addDays } from 'date-fns';
import { useCallback } from 'react';
import { ARROW_DOWN_KEY, ARROW_LEFT_KEY, ARROW_RIGHT_KEY, ARROW_UP_KEY, } from '#constants';
import { useDatePickerContext } from '../../context/useDatePickerContext';
import { WEEKS_TO_RENDER } from '../../DatePicker.constants';
import { DatePickerTestIdFactory } from '../../interactions/DatePicker.interactions';
import { Week } from '../Week';
import styles from './Calendar.module.css';
export const Calendar = ({ 'data-testid': testId }) => {
    _react_refresh_temp_2();
    const { dateWordings, focusedDate, setFocusedDate, setIsCalendarOpen } = useDatePickerContext();
    const onKeyDownCalendar = useCallback((event) => {
        // Edge case if used in a modal or other entity that depends on "Escape" key
        if (event.key === 'Escape') {
            event.stopPropagation();
            event.preventDefault();
            setIsCalendarOpen(false);
        }
        if (event.key === ARROW_UP_KEY && event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            setIsCalendarOpen(false);
        }
        if ([
            ARROW_DOWN_KEY,
            ARROW_LEFT_KEY,
            ARROW_UP_KEY,
            ARROW_RIGHT_KEY,
        ].includes(event.key)) {
            event.preventDefault();
            let newDate = new Date(focusedDate);
            if (event.key === ARROW_LEFT_KEY) {
                newDate = addDays(newDate, -1);
            }
            if (event.key === ARROW_RIGHT_KEY) {
                newDate = addDays(newDate, 1);
            }
            if (event.key === ARROW_UP_KEY) {
                newDate = addDays(newDate, -7);
            }
            if (event.key === ARROW_DOWN_KEY) {
                newDate = addDays(newDate, 7);
            }
            setFocusedDate(newDate);
        }
    }, [focusedDate, setFocusedDate, setIsCalendarOpen]);
    return (_jsxs("table", { className: styles.Container, "data-testid": DatePickerTestIdFactory.getDatePickerCalendarTestId(testId), role: "grid", children: [_jsx("thead", { children: _jsx("tr", { className: styles.WeekDaysHeader, children: dateWordings.dayNames.map((weekDay) => {
                        const firstLetter = weekDay[0];
                        return (_jsx("th", { "aria-label": weekDay, className: styles.WeekDay, children: firstLetter }, weekDay));
                    }) }) }), _jsx("tbody", { onKeyDown: onKeyDownCalendar, children: [...Array(WEEKS_TO_RENDER).keys()].map((weekIndex) => (_jsx(Week, { "data-testid": testId, weekIndex: weekIndex }, weekIndex))) })] }));
};
_react_refresh_temp_1 = Calendar;
$RefreshReg$(_react_refresh_temp_1, "Calendar");
_react_refresh_temp_2(Calendar, "hmKL5AOAHtiRwAIFMvv5VwlKkbg=", false, () => [useDatePickerContext]);
